<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Edit Data Author</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="9">
              <CInput
                  v-model.trim="authorForm.author_name"
                  label="Nama"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Title"
                  :is-valid="authorForm.author_name && authorForm.author_name.length > 65 ? false : null"
                  invalid-feedback="Title more than 65 characters"
                  @change="handleCorporateActionTitle"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <CInput
                  id="corporate_slug"
                  label="Slug"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Url Name"
                  v-model.trim="authorForm.author_slug"
                  @change="handleCorporateActionSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <CInput
                  label="Deskripsi"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Author Description"
                  v-model="authorForm.author_desc"
                  @change="handleMetaDescription"
              />
            </CCol>
          </CRow>
          <!-- Banner Desktop -->
          <CRow class="form-group">
            <CCol :col="9">
              <div class="warning-input" v-if="imageIs === 'KOSONG'">
                Foto Banner di perlukan
              </div>
              <CInputFile
                  label="Banner Desktop"
                  horizontal
                  type="file"
                  :is-valid="false"
                  :invalid-feedback="error.author_banner.message"
                  @change="readBanner"
              >
                <template v-slot:label-after-input>
                  File size should be below 2 MB and Optimize picture size is 1440px x 800px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <img class="image-ilustrasi" id="myImg" v-if="bannerUrl && !error.author_banner.message" :src="bannerUrl"/>
            </CCol>
          </CRow>

            <!-- Banner Mobile -->
          <CRow class="form-group">
            <CCol :col="9">
              <div class="warning-input" v-if="imageIs === 'KOSONG'">
                Foto Banner di perlukan
              </div>
              <CInputFile
                  label="Banner Mobile"
                  horizontal
                  type="file"
                  :is-valid="false"
                  :invalid-feedback="error.author_banner_mobile.message"
                  @change="readBannerMobile"
              >
                <template v-slot:label-after-input>
                  File size should be below 2 MB and Optimize picture size is 360px x 640px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <img class="image-ilustrasi" id="myImg" v-if="bannerUrlMobile && !error.author_banner_mobile.message" :src="bannerUrlMobile"/>
            </CCol>
          </CRow>

            <!-- Banner Avatar -->
          <CRow class="form-group">
            <CCol :col="9">
              <div class="warning-input" v-if="imageIs === 'KOSONG'">
                Foto Banner di perlukan
              </div>
              <CInputFile
                  label="Profile Picture"
                  horizontal
                  type="file"
                  :is-valid="false"
                  :invalid-feedback="error.author_avatar.message"
                  @change="readAvatar"
              >
                <template v-slot:label-after-input>
                  File size should be below 2 MB and Optimize picture size is 140px x 140px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <img class="image-avatar" id="myImg" v-if="avatarUrl && !error.author_avatar.message" :src="avatarUrl"/>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
                <div> Sosial Media</div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <CInput
                  label="Facebook"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Facebook"
                  v-model="authorForm.author_facebook_url"
                  @change="handleFacebook"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <CInput
                  label="X"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="X"
                  v-model="authorForm.author_x_url"
                  @change="handleX"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <CInput
                 label="LinkedIn"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="LinkedIn"
                  v-model="authorForm.author_in_url"
                  @change="handleLinkedIn"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <LanguageRadioGroup
                  :horizontal="true"
                  v-model="authorForm.language"
                  name="cms-corporate-author-edit-language"
                  id-prefix="cms-corporate-author-edit-language"
                  test-id="cms-corporate-author-edit-language"
                  @change="onLanguageChange"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <CSelect
                  label="Status"
                  :options="optionsStatus"
                  required
                  horizontal
                  v-model="authorForm.author_status"
                  @change="handleStatusCorporateAction"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                  color="success"
                  class="float-right"
                  data-testid="cms-corporate-author-edit-submit"
                  @click="updateCorporateAction"
              >Submit
              </CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import Swal from "sweetalert2";
import moment from "moment";
import jwt from "jsonwebtoken";
import {validateImageHeightAndWidth} from "./helper";
import CorporateAuthorUseCase from "./app/usecase";
import LanguageRadioGroup from "../../../components/LanguageRadioGroup.vue";
import { DEFAULT_AUTHOR_LANGUAGE, createEmptyAuthorForm } from "./app/types";

export default {
  name: "CorporateActionEdit",
  components: { LanguageRadioGroup },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  data() {
    return {
      authorForm: createEmptyAuthorForm(),
      hydrationMeta: {
        hadPersistedLanguage: true,
        languageDirty: false,
        persistedLanguage: DEFAULT_AUTHOR_LANGUAGE,
      },
      imageIs: "ADA",
      optionsStatus: ["ACTIVE", "INACTIVE"],
      isLoading: false,
      isSubmitting: false,
      loadError: null,
      bannerUrl: null,
      bannerUrlMobile: null,
      avatarUrl: null,
      error: {
        author_banner: {
          message: ''
        },
        author_banner_mobile: {
          message: ''
        },
        author_avatar: {
          message: ''
        }
      }
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
  },
  computed: {},
  methods: {
     async checkAuthor(name) {
      const { data: available, err } = await CorporateAuthorUseCase.checkAvailable(
        name,
        this.authorForm.language
      );

      if (err) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err,
        });
        return;
      }

      if (available === false) {
        this.authorForm.author_name = "";
        this.authorForm.author_slug = "";
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Author telah tersedia",
        });
      }
    },
    async getDataByID() {
      const corporateActionId = this.$route.params.id;
      this.isLoading = true;
      this.loadError = null;

      const { data, err } = await CorporateAuthorUseCase.getOne(corporateActionId);

      this.isLoading = false;

      if (err || !data) {
        this.loadError = err;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err,
        });
        return;
      }

      const { form, meta } = CorporateAuthorUseCase.hydrateForm(data, DEFAULT_AUTHOR_LANGUAGE);
      form.created_at = moment(String(data.created_at)).format("YYYY-MM-DD");

      this.authorForm = form;
      this.hydrationMeta = meta;
      this.bannerUrlMobile = form.author_banner_mobile;
      this.bannerUrl = form.author_banner;
      this.avatarUrl = form.author_avatar;
    },
    onLanguageChange() {
      this.hydrationMeta.languageDirty = true;
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({path: `/`});
      }
    },
    goBack() {
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({path: "/management/corporate-author"});
    },
    handleCorporateActionTitle(event) {
      var slug = event
          .replaceAll(/[^A-Za-z0-9 -]/g, "")
          .replaceAll(" ", "-")
          .replaceAll("--", "-")
          .toLowerCase()
          .trim();
      document.getElementById("corporate_slug").value = slug;
      this.authorForm.author_slug = slug;
      this.authorForm.author_name = event;
      this.checkAuthor(event)
    },
    handleCorporateActionSlug(event) {
      var slug = event
          .replaceAll(/[^A-Za-z0-9 -]/g, "")
          .replaceAll(" ", "-")
          .replaceAll("--", "-")
          .toLowerCase()
          .trim();
      document.getElementById("corporate_slug").value = slug;
      this.authorForm.author_slug = slug;
    },
    handleStatusCorporateAction(event) {
      this.authorForm.author_status = event.target.value;
    },
    handleMetaDescription(event) {
      this.authorForm.author_desc = event;
    },
    handleFacebook(event) {
      this.authorForm.author_facebook_url = event;
    },
    handleX(event) {
      this.authorForm.author_x_url = event;
    },
    handleLinkedIn(event) {
      this.authorForm.author_in_url = event;
    },
    async readBannerMobile(event) {
      const file = event[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file, false, true)
      this.bannerUrlMobile = dataUrl
      this.error.author_banner_mobile.message = err
      this.authorForm.author_banner_mobile = event[0];
    },
    async readAvatar(event) {
      const file = event[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file, true, false)
      this.avatarUrl = dataUrl
      this.error.author_avatar.message = err
      this.authorForm.author_avatar = event[0];
    },
    async readBanner(e) {
      const file = e[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file)
      this.bannerUrl = dataUrl
      this.error.author_banner.message = err
      this.authorForm.author_banner = e[0];
    },
    async updateCorporateAction() {
      if (
          this.authorForm.author_banner['size'] > 2000000 ||
          this.authorForm.author_banner_mobile['size'] > 2000000 ||
          this.authorForm.author_avatar['size'] > 2000000
      ) {

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Picture too big. Please upload below 250 KB",
        });
        return;
      } else {
        if (this.error.author_banner.message || this.error.author_avatar.message || this.error.author_banner_mobile.message) {
          Swal.fire({
          icon: "error",
          title: "Oops...",
          text: this.error.author_banner.message || this.error.author_avatar.message || this.error.author_banner_mobile.message,
        });
        return;
        }
      }

      const corporateActionId = this.$route.params.id;
      const command = CorporateAuthorUseCase.buildUpdateCommand(this.authorForm, this.hydrationMeta);

      this.isSubmitting = true;
      const { err } = await CorporateAuthorUseCase.updateOne(corporateActionId, command);
      this.isSubmitting = false;

      if (err) {
        this.authorForm.created_at = moment(
            String(this.authorForm.created_at)
        ).format("YYYY-MM-DD");
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err,
        });
        return;
      }

      Swal.fire({
        icon: "success",
        title: `Author Data Updated`,
        showConfirmButton: false,
        timer: 2000,
      });
      this.hydrationMeta.languageDirty = false;
      this.hydrationMeta.hadPersistedLanguage = true;
      this.hydrationMeta.persistedLanguage = this.authorForm.language;
    },
  },
  validator(val) {
    return val ? val.length >= 4 : false;
  },
};
</script>

<style scoped>
@import "./CorporateAuthor.css";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
